import { Td, Tr } from "../../ui/Table";

const TableSkeletonLoader = ({ length }) => {
  return (
    <>
      {[...Array(length)].map(() => {
        return (
          <Td className="">
            <div role="status" class="animate-pulse">
              <div class="h-[10px] bg-gray-200 rounded-lg dark:bg-gray-700"></div>
              <span class="sr-only">Loading...</span>
            </div>
          </Td>
        );
      })}
    </>
  );
};
export default TableSkeletonLoader;
